const getUserrole = state => state.role;

const getUserfreeProfileQuota = state => state.freeProfileQuota;

const getUserisDeleted = state => state.isDeleted;

const getUserId = state => state._id;

const getUserusername = state => state.username;

const getUseremail = state => state.email;

const profile = state => state.profile;

const profileLoading = state => state.profileLoading;

const resetPassword = state => state.resetPassword;

const resetPasswordLoading = state => state.resetPasswordLoading;

const changePassword = state => state.changePassword;

const changePasswordLoading = state => state.changePasswordLoading;

export default {
  getUserrole,
  getUserfreeProfileQuota,
  getUserisDeleted,
  getUserId,
  getUserusername,
  getUseremail,
  profile,
  profileLoading,
  resetPassword,
  resetPasswordLoading,
  changePassword,
  changePasswordLoading
};
